module.exports = __webpack_public_path__ + "static/img/login2.5390a4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/login2.png
// module id = 1242
// module chunks = 0